import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-nps-customer-survey.component.scss';
var FormItemNpsCustomerSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNpsCustomerSurvey, _super);
    function FormItemNpsCustomerSurvey(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = "";
        return _this;
    }
    FormItemNpsCustomerSurvey.prototype.init = function () {
        // form
        this.form = this.element.querySelector('form');
        this.nextStepButton1 = this.element.querySelector(".js_next-step-button1");
        this.nextStepButton2 = this.element.querySelector(".js_next-step-button2");
        this.nextStepButton3 = this.element.querySelector(".js_next-step-button3");
        this.nextStepButton4 = this.element.querySelector(".js_next-step-button4");
        this.nextStepButton5 = this.element.querySelector(".js_next-step-button5");
        this.nextStepButton6 = this.element.querySelector(".js_next-step-button6");
        this.nextStepButton7 = this.element.querySelector(".js_next-step-button7");
        this.wizard = this.element.querySelector('.form-container-wizard__wizard');
        this.wizardDisplay = this.element.querySelector('.form-container-wizard__counter');
        this.hasAccount = Array.from(this.element.querySelectorAll("input[name=\"hasStndBankAcc\"]"));
        this.achievedGoals = Array.from(this.element.querySelectorAll("input[name=\"achievedGoals\"]"));
        this.hasAccountVal = "";
        this.achievedGoalsVal = "";
        this.recommendRange = Array.from(this.element.querySelectorAll("input[name=\"recommendRange\"]"));
        this.recommendRangeVal = "";
        this.experienceRange = Array.from(this.element.querySelectorAll("input[name=\"experienceRange\"]"));
        this.experienceRangeVal = "";
        this.easyToFindRange = Array.from(this.element.querySelectorAll("input[name=\"easyToFindRange\"]"));
        this.easyToFindRangeVal = "";
        this.informationRange = Array.from(this.element.querySelectorAll("input[name=\"informationRange\"]"));
        this.informationRangeVal = "";
        this.accessRange = Array.from(this.element.querySelectorAll("input[name=\"accessRange\"]"));
        this.accessRangeVal = "";
        this.personalInfoRange = Array.from(this.element.querySelectorAll("input[name=\"personalInfoRange\"]"));
        this.personalInfoRangeVal = "";
        this.applyRange = Array.from(this.element.querySelectorAll("input[name=\"applyRange\"]"));
        this.applyRangeVal = "";
        this.applyRangePrevVal = "";
        this.viewUseRange = Array.from(this.element.querySelectorAll("input[name=\"viewUseRange\"]"));
        this.viewUseRangeVal = "";
        this.viewUseRangePrevVal = "";
        this.applyNotApplicableInput = this.element.querySelector("input[name=\"applyNotApplicable\"]");
        this.viewUseNotApplicableInput = this.element.querySelector("input[name=\"viewUseNotApplicable\"]");
        this.otherThoughtsInput = this.element.querySelector("textarea[name=\"otherThoughts\"]");
        // Clear all checked selections on load
        var allRadioButtons = Array.from(this.element.querySelectorAll("input[type=\"radio\"]"));
        allRadioButtons.forEach(function (radio) {
            if (radio.checked === true) {
                radio.checked = false;
                radio.removeAttribute('checked');
            }
        });
        // buttons
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-npsSurvey__button--submit'));
    };
    FormItemNpsCustomerSurvey.prototype.bindEvents = function () {
        var _this = this;
        if (this.wizardDisplay) {
            this.wizardDisplay.classList.add("nps-customer-survey__wizardDisplayHide");
        }
        // Get radio selection value
        if (this.hasAccount) {
            this.hasAccount.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.hasAccountVal = _radio.value;
                });
            });
        }
        // Get radio selection value
        if (this.achievedGoals) {
            this.achievedGoals.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.achievedGoalsVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.recommendRange) {
            this.recommendRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.recommendRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.experienceRange) {
            this.experienceRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.experienceRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.easyToFindRange) {
            this.easyToFindRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.easyToFindRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.informationRange) {
            this.informationRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.informationRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.accessRange) {
            this.accessRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.accessRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.personalInfoRange) {
            this.personalInfoRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.personalInfoRangeVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.applyRange) {
            this.applyRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.applyRangeVal = _radio.value;
                    _this.applyRangePrevVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection value
        if (this.viewUseRange) {
            this.viewUseRange.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.viewUseRangeVal = _radio.value;
                    _this.viewUseRangePrevVal = _radio.value;
                });
            });
        }
        // Get radio-rating selection or 'not appliable' value
        if (this.applyNotApplicableInput) {
            this.applyNotApplicableInput.addEventListener('change', function (event) {
                if (_this.applyNotApplicableInput.checked) {
                    _this.clearSelectionErrors(_this.applyRange);
                    _this.applyRange.forEach(function (_radio) {
                        _radio.disabled = true;
                        var fieldSpan = _radio.closest('label.nps-customer-survey.custom-radio')
                            .querySelector('span.nps-customer-survey.circle');
                        if (fieldSpan) {
                            fieldSpan.classList.add('circle-grey');
                        }
                    });
                    _this.applyRangePrevVal = _this.applyRangeVal;
                    _this.applyRangeVal = '0';
                }
                else {
                    _this.applyRange.forEach(function (_radio) {
                        _radio.disabled = false;
                        var fieldSpan = _radio.closest('label.nps-customer-survey.custom-radio')
                            .querySelector('span.nps-customer-survey.circle');
                        if (fieldSpan) {
                            fieldSpan.classList.remove('circle-grey');
                        }
                    });
                    _this.applyRangeVal = _this.applyRangePrevVal;
                }
            });
        }
        // Get radio-rating selection or 'not appliable' value
        if (this.viewUseNotApplicableInput) {
            this.viewUseNotApplicableInput.addEventListener('change', function (event) {
                if (_this.viewUseNotApplicableInput.checked) {
                    _this.clearSelectionErrors(_this.viewUseRange);
                    _this.viewUseRange.forEach(function (_radio) {
                        _radio.disabled = true;
                        var fieldSpan = _radio.closest('label.nps-customer-survey.custom-radio')
                            .querySelector('span.nps-customer-survey.circle');
                        if (fieldSpan) {
                            fieldSpan.classList.add('circle-grey');
                        }
                    });
                    _this.viewUseRangePrevVal = _this.viewUseRangeVal;
                    _this.viewUseRangeVal = '0';
                }
                else {
                    _this.viewUseRange.forEach(function (_radio) {
                        _radio.disabled = false;
                        var fieldSpan = _radio.closest('label.nps-customer-survey.custom-radio')
                            .querySelector('span.nps-customer-survey.circle');
                        if (fieldSpan) {
                            fieldSpan.classList.remove('circle-grey');
                        }
                    });
                    _this.viewUseRangeVal = _this.viewUseRangePrevVal;
                }
            });
        }
        // Validate if radio selections have been made on current step
        if (this.nextStepButton2) {
            this.nextStepButton2.addEventListener("click", function (event) {
                // Clear errors
                _this.clearSelectionErrors(_this.hasAccount);
                _this.clearSelectionErrors(_this.achievedGoals);
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.hasAccount, _this.hasAccountVal, true);
                var isValid2 = _this.ratingSelectionValidation(_this.achievedGoals, _this.achievedGoalsVal, true);
                if (!isValid || !isValid2) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Validate if radio-rating selections have been made on current step
        if (this.nextStepButton3) {
            this.nextStepButton3.addEventListener("click", function (event) {
                // Clear errors
                _this.clearSelectionErrors(_this.recommendRange);
                _this.clearSelectionErrors(_this.experienceRange);
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.recommendRange, _this.recommendRangeVal);
                var isValid2 = _this.ratingSelectionValidation(_this.experienceRange, _this.experienceRangeVal);
                if (!isValid || !isValid2) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Validate if radio-rating selections have been made on current step
        if (this.nextStepButton4) {
            this.nextStepButton4.addEventListener("click", function (event) {
                // Clear errors
                _this.clearSelectionErrors(_this.easyToFindRange);
                _this.clearSelectionErrors(_this.informationRange);
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.easyToFindRange, _this.easyToFindRangeVal);
                var isValid2 = _this.ratingSelectionValidation(_this.informationRange, _this.informationRangeVal);
                if (!isValid || !isValid2) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Validate if radio-rating selections have been made on current step
        if (this.nextStepButton5) {
            this.nextStepButton5.addEventListener("click", function (event) {
                // Clear errors
                _this.clearSelectionErrors(_this.accessRange);
                _this.clearSelectionErrors(_this.personalInfoRange);
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.accessRange, _this.accessRangeVal);
                var isValid2 = _this.ratingSelectionValidation(_this.personalInfoRange, _this.personalInfoRangeVal);
                if (!isValid || !isValid2) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Validate if radio-rating selections have been made on current step
        if (this.nextStepButton6) {
            this.nextStepButton6.addEventListener("click", function (event) {
                _this.clearSelectionErrors(_this.applyRange); // Clear errors
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.applyRange, _this.applyRangeVal);
                if (!isValid) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Validate if radio-rating selections have been made on current step
        if (this.nextStepButton7) {
            this.nextStepButton7.addEventListener("click", function (event) {
                _this.clearSelectionErrors(_this.viewUseRange);
                ; // Clear errors
                // Check if a selection has been made
                var isValid = _this.ratingSelectionValidation(_this.viewUseRange, _this.viewUseRangeVal);
                if (!isValid) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        // Submit form
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select, textarea');
            _this.validationService.validate(formFields);
            // Additional validation step for selected values
            var formValid = _this.additionalValidationCheck();
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0 && formValid) {
                // screens
                var loader = _form.querySelector(".form__loader--container");
                var fieldsContainer = _form.querySelector(".form__fields--container");
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                fieldsContainer.classList.remove('active');
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != "") {
                    var gToken_1 = "";
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        }); });
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent('custom_wizard_reset_event');
                _this.wizard.dispatchEvent(event_1);
            }
        }, false);
    };
    // Clear validation errors
    FormItemNpsCustomerSurvey.prototype.clearSelectionErrors = function (range) {
        var selectionArray = [];
        // Radio Details Selection Error
        var hasSelectionGroup = range[0].closest(".form__group");
        selectionArray.push(hasSelectionGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
    };
    // Validate if a radio selection has been made
    FormItemNpsCustomerSurvey.prototype.ratingSelectionValidation = function (range, rangeValue, _2RadioSelections) {
        var isValid = true;
        var selectionErrorDetails = (_2RadioSelections) ? "This field is required" : "Please select your rating";
        // Radio Selection Error Check
        var hasSelectionGroup = range[0].closest(".form__group");
        if (hasSelectionGroup) {
            if (rangeValue === "") {
                isValid = false;
                hasSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = selectionErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                hasSelectionGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemNpsCustomerSurvey.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // loader + hide form
        loader.classList.add('active');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/leadsutils/createnpscs';
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var _postData = {
            sbsaCustomer: this.hasAccountVal,
            achieveEverythingOnWebsite: this.achievedGoalsVal,
            recommendSBSARating: this.recommendRangeVal,
            overallExperienceRating: this.experienceRangeVal,
            easyToFindIamLookingFor: this.easyToFindRangeVal,
            informationIsClearAndHelpFul: this.informationRangeVal,
            accessWebsiteWithConsistentOrDowntime: this.accessRangeVal,
            feelSafeToShareMyPersonalInfo: this.personalInfoRangeVal,
            easyToApplyForProductsOrRequestServices: this.applyNotApplicableInput.checked ? '0' : this.applyRangeVal,
            easyToViewAndUseWebsiteOnMobile: this.viewUseNotApplicableInput.checked ? '0' : this.viewUseRangeVal,
            otherOpenFeedback: this.otherThoughtsInput.value,
            productPage: window.location.href,
        };
        // service
        this.formsService.postForm(url, _postData, config).then(function (response) {
            loader.classList.remove('active');
            if (response.data == null || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                thankYou.classList.add('active');
                error.classList.remove('hidden');
                error.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.code);
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
                var isSurveyCompleted = 'true';
                localStorage.setItem(_this.surveyInfoService.getSurveyCompleteName(), isSurveyCompleted);
                _this.surveyInfoService.setTimeExpired();
            }
            // reset form values
            _this.resetForm();
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            thankYou.classList.add('active');
            error.classList.remove('hidden');
            error.classList.add('active');
            success.classList.remove('active');
            success.classList.add('hidden');
            // reset form values
            _this.resetForm();
        });
    };
    // * Additional validation step for selected values
    // * Ensure only specific values have been selected
    // 	 before passing data to API
    FormItemNpsCustomerSurvey.prototype.additionalValidationCheck = function () {
        var yesNoReg = /^[a-zA-Z]{2,3}$/;
        var otherRangesReg = /^[1-5]$/;
        var otherRanges2Reg = /^[0-5]$/;
        var recommendRangeReg = /^([0-9]|10)$/;
        var experienceRangeReg = /^([1-9]|10)$/;
        var otherThoughtsReg = /[`~!@#$%^&*()_+=\[\]{};:"\\|<>\/?]/;
        var formValid = true;
        if (!yesNoReg.test(this.hasAccountVal)) {
            formValid = false;
        }
        if (!yesNoReg.test(this.achievedGoalsVal)) {
            formValid = false;
        }
        if (!recommendRangeReg.test(this.recommendRangeVal)) {
            formValid = false;
        }
        if (!experienceRangeReg.test(this.experienceRangeVal)) {
            formValid = false;
        }
        if (!otherRangesReg.test(this.easyToFindRangeVal)) {
            formValid = false;
        }
        if (!otherRangesReg.test(this.informationRangeVal)) {
            formValid = false;
        }
        if (!otherRangesReg.test(this.accessRangeVal)) {
            formValid = false;
        }
        if (!otherRangesReg.test(this.personalInfoRangeVal)) {
            formValid = false;
        }
        if (!otherRanges2Reg.test(this.applyRangeVal)) {
            formValid = false;
        }
        if (!otherRanges2Reg.test(this.viewUseRangeVal)) {
            formValid = false;
        }
        if (otherThoughtsReg.test(this.otherThoughtsInput.value)) {
            formValid = false;
        }
        return formValid;
    };
    FormItemNpsCustomerSurvey.prototype.resetForm = function () {
        this.applyNotApplicableInput.checked = false;
        this.viewUseNotApplicableInput.checked = false;
        this.hasAccountVal = "";
        this.achievedGoalsVal = "";
        this.recommendRangeVal = "";
        this.experienceRangeVal = "";
        this.easyToFindRangeVal = "";
        this.informationRangeVal = "";
        this.accessRangeVal = "";
        this.personalInfoRangeVal = "";
        this.applyRangeVal = "";
        this.viewUseRangeVal = "";
        this.otherThoughtsInput.value = "";
        // reset form values
        this.form.reset();
    };
    return FormItemNpsCustomerSurvey;
}(Base));
export { FormItemNpsCustomerSurvey };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-nps-customer-survey/form-item-nps-customer-survey.component.ts
// module id = 961
// module chunks = 0